import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { ROOM_MOVE_REPORT_ENDPOINT } from '../endpoint';
import { RoomMoveReportRequestModel } from '../models/RoomMoveReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: RoomMoveReportRequestModel): Promise<void> => {
    return await axios
      .get(`${ROOM_MOVE_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'room-move-report',
        });
      });
  };
